import type { QuestionnaireBook } from './onboarding.types'

/**
 * These books were selected from the following query:
 *
 * SELECT DISTINCT d.id, d.title, d.cover_image, d.popularity_user_count_90
 * FROM doc d
 * JOIN tag_to_doc ttd ON d.id = ttd.doc_id
 * JOIN tag t ON ttd.tag_id = t.id
 * WHERE d.doc_type = 'book'
 *   AND d.is_published = true
 *   AND d.is_ai = false
 *   AND t.name IN ({{ categories }})
 * ORDER BY d.popularity_user_count_90 desc
 * LIMIT 15;
 *
 * Where `{{ categories }}` are the categories for each genre:
 *
 * business: 'Business', 'Economics', 'Entrepreneurship', 'Marketing', 'Money', 'Sales'
 * leadership: 'Management/Leadership'
 * relationships: 'Relationships', 'Parenting'
 * productivity: 'Motivation', 'Productivity', 'Self-Improvement'
 * health: 'Spirituality', 'Lifestyle', 'Food', 'Health'
 * communication: 'Communication'
 */
export const QUESTIONNAIRE_BOOKS: readonly QuestionnaireBook[] = [
  {
    id: '26254e5a-8283-499f-94d3-e2e1befbc2f4',
    title: 'Atomic Habits',
    cover: '//media.shortform.com/covers/png/atomic-habits-cover.png',
    popularity: 1765,
    genre: ['productivity'],
  },
  {
    id: 'addfc49a-1e35-4190-b909-2ebe89b10e49',
    title: 'The ChatGPT Millionaire',
    cover:
      '//media.shortform.com/covers/png/the-chatgpt-millionaire-neil-dagger-cover.png',
    popularity: 1169,
    genre: ['communication'],
  },
  {
    id: 'f593c49c-fd10-4d89-b5fa-ae621e14329a',
    title: 'The Let Them Theory',
    cover: '//media.shortform.com/covers/png/the-let-them-theory-cover.png',
    popularity: 1117,
    genre: ['productivity'],
  },
  {
    id: 'bfe69bc6-d2f0-415c-abe9-2559542539c4',
    title: 'Think Faster, Talk Smarter',
    cover:
      '//media.shortform.com/covers/png/think-faster-talk-smarter-cover.png',
    popularity: 1032,
    genre: ['productivity', 'communication'],
  },
  {
    id: '21077d89-ac1f-42b3-9629-530f45444e80',
    title: 'The 48 Laws of Power',
    cover: '//media.shortform.com/covers/png/the-48-laws-of-power-cover.png',
    popularity: 824,
    genre: ['leadership', 'productivity', 'communication'],
  },
  {
    id: '8a68a5b2-4f61-41d6-8ab3-5103bc0c007c',
    title: 'The 7 Habits of Highly Effective People',
    cover:
      '//media.shortform.com/covers/png/the-7-habits-of-highly-effective-people-cover.png',
    popularity: 556,
    genre: ['leadership', 'productivity'],
  },
  {
    id: '3d8a60cc-8639-4ec4-a94f-f37ad0b07959',
    title: 'Deep Work',
    cover: '//media.shortform.com/covers/png/deep-work-cover.png',
    popularity: 555,
    genre: ['productivity'],
  },
  {
    id: 'f57326b7-844d-4647-9153-49a209df5a21',
    title: 'Thinking, Fast and Slow',
    cover: '//media.shortform.com/covers/png/thinking-fast-and-slow-cover.png',
    popularity: 530,
    genre: ['business'],
  },
  {
    id: '570f37cd-854c-4475-b883-688d1f4be078',
    title: 'How to Win Friend and Influence People',
    cover:
      '//media.shortform.com/covers/png/how-to-win-friends-and-influence-people-cover.png',
    popularity: 440,
    genre: ['productivity', 'communication'],
  },
  {
    id: '1e3b64b0-00ca-43dc-b1c8-ff5bc9697f54',
    title: 'The Subtle Art of Not Giving a F*ck',
    cover:
      '//media.shortform.com/covers/png/the-subtle-art-of-not-giving-a-fck-cover.png',
    popularity: 425,
    genre: ['productivity'],
  },
  {
    id: 'efd66568-d3e5-4957-9266-cacd79ac5be1',
    title: 'The Psychology of Money',
    cover: '//media.shortform.com/covers/png/the-psychology-of-money-cover.png',
    popularity: 419,
    genre: ['business'],
  },
  {
    id: '32ef3b84-4148-42f4-90d0-7421ef66f200',
    title: 'The Art of Seduction',
    cover: '//media.shortform.com/covers/png/the-art-of-seduction-cover.png',
    popularity: 395,
    genre: ['relationships'],
  },
  {
    id: '75a82fe3-120b-4eea-ac2c-bdb2024d797d',
    title: 'Habits of a Happy Brain',
    cover: '//media.shortform.com/covers/png/habits-of-a-happy-brain-cover.png',
    popularity: 374,
    genre: ['productivity'],
  },
  {
    id: '4710ca43-19f0-4997-be0f-51ac725a2aad',
    title: 'The First Rule of Mastery',
    cover:
      '//media.shortform.com/covers/png/the-first-rule-of-mastery-cover.png',
    popularity: 359,
    genre: ['productivity'],
  },
  {
    id: 'aa9184b8-387c-4ab7-b414-06849c5b84aa',
    title: 'Never Split the Difference',
    cover:
      '//media.shortform.com/covers/png/never-split-the-difference-cover.png',
    popularity: 341,
    genre: ['leadership', 'communication'],
  },
  {
    id: '4f595f14-e506-479e-b98b-5293ebd9f144',
    title: 'Exercised',
    cover: '//media.shortform.com/covers/png/exercised-cover.png',
    popularity: 331,
    genre: ['health'],
  },
  {
    id: 'ebdc66e7-d447-4722-b723-5588eea7afb7',
    title: 'Start Finishing',
    cover: '//media.shortform.com/covers/png/start-finishing-cover.png',
    popularity: 313,
    genre: ['productivity'],
  },
  {
    id: '1004234a-d6d6-48fa-8ad7-0f752622bc24',
    title: 'Stick With It',
    cover: '//media.shortform.com/covers/png/stick-with-it-cover.png',
    popularity: 288,
    genre: ['productivity', 'health'],
  },
  {
    id: '6a1e42fd-b5a0-495e-a571-b7646f2deba7',
    title: 'The Humor Habit',
    cover: '//media.shortform.com/covers/png/the-humor-habit-cover.png',
    popularity: 268,
    genre: ['leadership', 'productivity'],
  },
  {
    id: '33742120-9da7-4287-bd45-f7267ee3f36a',
    title: 'Awaken the Giant Within',
    cover: '//media.shortform.com/covers/png/awaken-the-giant-within-cover.png',
    popularity: 263,
    genre: ['relationships', 'productivity', 'communication'],
  },
  {
    id: '73dcb9c5-a864-4f46-823b-16b7b3360999',
    title: 'Meditations',
    cover: '//media.shortform.com/covers/png/meditations-cover.png',
    popularity: 255,
    genre: ['productivity'],
  },
  {
    id: '810c5fd4-d7d9-42f7-9295-2c22ce001119',
    title: '12 Rules for Life',
    cover: '//media.shortform.com/covers/png/12-rules-for-life-cover.png',
    popularity: 255,
    genre: ['health'],
  },
  {
    id: 'abb80dcb-84a8-474a-8a82-0b30089a8dcd',
    title: '$100M Offers',
    cover: '//media.shortform.com/covers/png/100m-offers-cover.png',
    popularity: 252,
    genre: ['business'],
  },
  {
    id: '52cc72c9-4255-4d54-aaf4-9e965ef8d58f',
    title: 'How to Talk to Anyone',
    cover: '//media.shortform.com/covers/png/how-to-talk-to-anyone-cover.png',
    popularity: 244,
    genre: ['communication'],
  },
  {
    id: '87e10382-420f-43d5-9e0c-75a9bff45841',
    title: 'Brain Wash',
    cover: '//media.shortform.com/covers/png/brain-wash-cover.png',
    popularity: 241,
    genre: ['health'],
  },
  {
    id: '3f8a116e-6491-4954-a216-7f7b651e8800',
    title: 'The Diary of a CEO',
    cover: '//media.shortform.com/covers/png/the-diary-of-a-ceo-cover.png',
    popularity: 221,
    genre: ['business'],
  },
  {
    id: '6530963c-1d93-4a04-bcb7-e33ecebbd4da',
    title: 'Principles of Life and Work',
    cover:
      '//media.shortform.com/covers/png/principles-life-and-work-cover.png',
    popularity: 210,
    genre: ['leadership', 'communication'],
  },
  {
    id: '343a6518-8f80-47c9-9e51-c6cb413a4efc',
    title: 'The Laws of Human Nature',
    cover:
      '//media.shortform.com/covers/png/the-laws-of-human-nature-cover.png',
    popularity: 208,
    genre: ['leadership', 'communication'],
  },
  {
    id: '31f45443-26cb-44ed-9403-1cbbc17d4b99',
    title: 'Good to Great',
    cover: '//media.shortform.com/covers/png/good-to-great-cover.png',
    popularity: 207,
    genre: ['business', 'leadership'],
  },
  {
    id: 'db816204-cb70-4e2a-b20c-82ffa8f3a89b',
    title: 'Mindset',
    cover: '//media.shortform.com/covers/png/mindset-cover.png',
    popularity: 204,
    genre: ['communication'],
  },
  {
    id: 'cb0e19e1-6f1f-4290-9c50-73ffb3c35afd',
    title: 'The Art of Explanation',
    cover: '//media.shortform.com/covers/png/the-art-of-explanation-cover.png',
    popularity: 200,
    genre: ['communication'],
  },
  {
    id: '66712da5-893e-4151-9844-37b8007d0b38',
    title: 'Collaborating with the Enemy',
    cover:
      '//media.shortform.com/covers/png/collaborating-with-the-enemy-cover.png',
    popularity: 195,
    genre: ['communication'],
  },
  {
    id: 'a7ae68fa-bbf6-42a4-85e7-e0d35448de45',
    title: 'Influence',
    cover: '//media.shortform.com/covers/png/influence-cover.png',
    popularity: 192,
    genre: ['communication'],
  },
  {
    id: '19c415b2-eb23-46d9-b1b2-36417f92510c',
    title: 'Never Play it Safe',
    cover: '//media.shortform.com/covers/png/never-play-it-safe-cover.png',
    popularity: 191,
    genre: ['health'],
  },
  {
    id: '9b20dd33-f829-4d1d-b11f-3e1c0dac25a0',
    title: 'The Power of Now',
    cover: '//media.shortform.com/covers/png/the-power-of-now-cover.png',
    popularity: 190,
    genre: ['health'],
  },
  {
    id: '4228ead4-ef6c-4da4-a906-21f98bbaaf5b',
    title: 'Thinking in Systems',
    cover: '//media.shortform.com/covers/png/thinking-in-systems-cover.png',
    popularity: 183,
    genre: ['business'],
  },
  {
    id: '6bfd44f3-c6cf-4871-b0a9-687557fa0078',
    title: 'The Code of the Extraordinary Mind',
    cover:
      '//media.shortform.com/covers/png/the-code-of-the-extraordinary-mind-cover.png',
    popularity: 181,
    genre: ['health'],
  },
  {
    id: 'f1a10e35-4125-42dd-b608-a1e1279ccb50',
    title: "The Founder's Dilemmas",
    cover: '//media.shortform.com/covers/png/the-founders-dilemmas-cover.png',
    popularity: 175,
    genre: ['business'],
  },
  {
    id: '5c350002-c2e4-4d63-ae10-b45c487ab180',
    title: '101 Essays That Will Change the Way You Think',
    cover:
      '//media.shortform.com/covers/png/101-essays-that-will-change-the-way-you-think-cover.png',
    popularity: 174,
    genre: ['health'],
  },
  {
    id: '9fb0498a-6456-4700-bd9e-dbf2590e84f8',
    title: 'Start with Why',
    cover: '//media.shortform.com/covers/png/start-with-why-cover.png',
    popularity: 171,
    genre: ['business', 'leadership'],
  },
  {
    id: 'd03f3906-9d57-460b-bbbf-8a3de6cba078',
    title: 'Essentialism',
    cover: '//media.shortform.com/covers/png/essentialism-cover.png',
    popularity: 170,
    genre: ['health'],
  },
  {
    id: '0dda119d-5a9d-49cb-97bd-6620325c8080',
    title: 'Antrifragile',
    cover: '//media.shortform.com/covers/png/antifragile-cover.png',
    popularity: 168,
    genre: ['business'],
  },
  {
    id: '86196eb9-9bac-461b-9e94-d0b1771c1a86',
    title: 'Emotional Intelligence',
    cover: '//media.shortform.com/covers/png/emotional-intelligence-cover.png',
    popularity: 165,
    genre: ['communication'],
  },
  {
    id: 'd08b3a6a-64e9-4b90-a3aa-a2c5f76e2dad',
    title: 'Writing for Busy Readers',
    cover:
      '//media.shortform.com/covers/png/writing-for-busy-readers-cover.png',
    popularity: 165,
    genre: ['communication'],
  },
  {
    id: 'a29385c0-6ca9-42e2-87aa-71e521c4ad78',
    title: 'Goodbye Things',
    cover: '//media.shortform.com/covers/png/goodbye-things-cover.png',
    popularity: 164,
    genre: ['health'],
  },
  {
    id: '916ff478-2a75-4636-8e31-98e7834a86a3',
    title: 'Abundance',
    cover:
      '//media.shortform.com/covers/png/abundance-ezra-klein-derek-thompson-cover.png',
    popularity: 163,
    genre: ['business'],
  },
  {
    id: '757f33b6-5092-494a-b260-d592afb410fa',
    title: '10x is Easier than 2x',
    cover: '//media.shortform.com/covers/png/10x-is-easier-than-2x-cover.png',
    popularity: 163,
    genre: ['leadership'],
  },
  {
    id: '4bc409af-eb17-40dd-980a-d0ac9b590a05',
    title: 'The Autoimmune Solution',
    cover: '//media.shortform.com/covers/png/the-autoimmune-solution-cover.png',
    popularity: 163,
    genre: ['health'],
  },
  {
    id: '2afafb92-4daa-4994-a825-38bffff709a3',
    title: 'No Death, No Fear',
    cover: '//media.shortform.com/covers/png/no-death-no-fear-cover.png',
    popularity: 162,
    genre: ['health'],
  },
  {
    id: '9c2ad918-a7a6-461d-a514-5f00430843b4',
    title: 'Crucial Conversations',
    cover: '//media.shortform.com/covers/png/crucial-conversations-cover.png',
    popularity: 158,
    genre: ['leadership'],
  },
  {
    id: 'a8a634a4-0447-4004-9a79-cce23153f80a',
    title: 'Think and Grow Rich',
    cover: '//media.shortform.com/covers/png/think-and-grow-rich-cover.png',
    popularity: 157,
    genre: ['leadership'],
  },
  {
    id: '29eb90c4-0a26-4826-904b-9d3571768d76',
    title: 'How to Know a Person',
    cover: '//media.shortform.com/covers/png/how-to-know-a-person-cover.png',
    popularity: 155,
    genre: ['relationships'],
  },
  {
    id: '76819cf6-abc8-4e83-be26-ea51918dce1f',
    title: 'The Body Keeps the Score',
    cover:
      '//media.shortform.com/covers/png/the-body-keeps-the-score-cover.png',
    popularity: 148,
    genre: ['health'],
  },
  {
    id: 'f73525a6-6499-4925-bc7d-4bcf9030081b',
    title: 'The Lean Startup',
    cover: '//media.shortform.com/covers/png/the-lean-startup-cover.png',
    popularity: 146,
    genre: ['business', 'leadership'],
  },
  {
    id: 'f330a096-5dbe-49e7-afd5-23e8d63e6bd6',
    title: 'Outlive',
    cover: '//media.shortform.com/covers/png/outlive-cover.png',
    popularity: 146,
    genre: ['health'],
  },
  {
    id: '20a740a8-35ec-4064-9f99-4d99743361e8',
    title: 'The Intelligest Investor',
    cover:
      '//media.shortform.com/covers/png/the-intelligent-investor-cover.png',
    popularity: 142,
    genre: ['business'],
  },
  {
    id: '2bc7595a-85ed-4830-ada8-d393f8e8b8cc',
    title: 'The One Thing',
    cover: '//media.shortform.com/covers/png/the-one-thing-cover.png',
    popularity: 141,
    genre: ['leadership'],
  },
  {
    id: 'd2e2d8ed-8dde-4579-9bb4-e7ffc9d35dc3',
    title: 'Principles for Dealing with the Changing World',
    cover:
      '//media.shortform.com/covers/png/principles-for-dealing-with-the-changing-world-order-cover.png',
    popularity: 140,
    genre: ['business'],
  },
  {
    id: 'bbdb2ece-af7b-4b0f-a5f4-b0bc1c2a1acb',
    title: "Man's Search for Meaning",
    cover: '//media.shortform.com/covers/png/mans-search-for-meaning-cover.png',
    popularity: 140,
    genre: ['health'],
  },
  {
    id: 'fa33f7a3-9696-4adf-abe7-deee9e5ce685',
    title: 'Rich Dad Poor Dad',
    cover: '//media.shortform.com/covers/png/rich-dad-poor-dad-cover.png',
    popularity: 139,
    genre: ['business'],
  },
  {
    id: '8e767dfa-df74-4383-9d09-5dbd08ce3256',
    title: 'The Art of War',
    cover: '//media.shortform.com/covers/png/the-art-of-war-cover.png',
    popularity: 136,
    genre: ['business', 'leadership'],
  },
  {
    id: '127aa171-b3f8-4f8e-aa8e-0169754dd1fd',
    title: 'Teaming',
    cover: '//media.shortform.com/covers/png/teaming-cover.png',
    popularity: 136,
    genre: ['leadership'],
  },
  {
    id: '3f23d19a-5d79-4064-b401-4aa5853885b0',
    title: 'The Way of the Superior Man',
    cover:
      '//media.shortform.com/covers/png/the-way-of-the-superior-man-cover.png',
    popularity: 129,
    genre: ['relationships'],
  },
  {
    id: 'dd1a8cb1-b9e1-4b3d-9ff0-4c74bf081d80',
    title: "The Man's Guide to Women",
    cover: '//media.shortform.com/covers/png/the-mans-guide-to-women-cover.png',
    popularity: 121,
    genre: ['relationships'],
  },
  {
    id: '001dbf21-396d-4e68-8836-b964f7b695a2',
    title: 'Hold me Tight',
    cover: '//media.shortform.com/covers/png/hold-me-tight-cover.png',
    popularity: 118,
    genre: ['relationships'],
  },
  {
    id: '908699fc-ed72-4bb9-8f24-872e65f4e598',
    title: 'No More Mr. Nice Guy',
    cover: '//media.shortform.com/covers/png/no-more-mr-nice-guy-cover.png',
    popularity: 109,
    genre: ['relationships'],
  },
  {
    id: '19511013-5ccb-4fa4-a093-002d5b589e56',
    title: 'The Six Pillars of Self Esteem',
    cover:
      '//media.shortform.com/covers/png/the-six-pillars-of-self-esteem-cover.png',
    popularity: 105,
    genre: ['relationships'],
  },
  {
    id: '77f275fa-a037-45c3-878b-24e525c0be71',
    title: 'The Fine Art of Small Talk',
    cover:
      '//media.shortform.com/covers/png/the-fine-art-of-small-talk-cover.png',
    popularity: 101,
    genre: ['relationships'],
  },
  {
    id: '10849af4-fe72-4253-9b17-7c19237741f7',
    title: 'Read People like a Book',
    cover: '//media.shortform.com/covers/png/read-people-like-a-book-cover.png',
    popularity: 100,
    genre: ['relationships'],
  },
  {
    id: '30856f4a-833a-450a-bc77-b32d09dd49c7',
    title: 'Powerful Phrases for Dealing with Difficult People',
    cover:
      '//media.shortform.com/covers/png/powerful-phrases-for-dealing-with-difficult-people-cover.png',
    popularity: 100,
    genre: ['relationships'],
  },
  {
    id: 'd4d21764-92a2-4d52-8f22-46707f1da6f6',
    title: 'Nonviolent Communication',
    cover:
      '//media.shortform.com/covers/png/nonviolent-communication-cover.png',
    popularity: 86,
    genre: ['relationships'],
  },
  {
    id: '2868d4a8-f419-494f-a535-34afc883e34b',
    title: 'Attached',
    cover: '//media.shortform.com/covers/png/attached-cover.png',
    popularity: 85,
    genre: ['relationships'],
  },
  {
    id: '362f2632-59ad-42b8-8f40-6e322e00ff6f',
    title: 'Models',
    cover: '//media.shortform.com/covers/png/models-cover.png',
    popularity: 84,
    genre: ['relationships'],
  },
  {
    id: 'ec74b4db-2fec-4d0a-87a9-9af141415fc1',
    title: 'Come as You Are',
    cover: '//media.shortform.com/covers/png/come-as-you-are-cover.png',
    popularity: 83,
    genre: ['relationships'],
  },
]
